$(document).ready(function(){
  if ($(window).width() < 530) {
      let slideHead = $('.footer__menu[role="navigation"]');
      let slideList = $('.footer__menu[role="navigation"] > ul');
      let slideBtn = $('.footer__menu[role="navigation"] > p');
    
      slideList.slideUp();

      slideBtn.click(function(){
        $(this).siblings('ul').slideToggle();
        $(this).toggleClass('active')
      })
  }

  
});

 // Footer Accordian Tabs Script START

// window.addEventListener('DOMContentLoaded', () => {
//   if (window.matchMedia('(min-width: 768px)').matches) {
//     return;
//   }

//   const handleCollapse = (heading) => {
//     const allMiddleHeadings = document.querySelectorAll('.grid .footer-block__heading.middle');

//     if (heading.classList.contains('block-collapsed')) {
//       // Close all other middle tabs before opening the clicked one
//       allMiddleHeadings.forEach((otherHeading) => {
//         if (!otherHeading.isSameNode(heading)) {
//           otherHeading.classList.add('block-collapsed');
//           otherHeading.setAttribute('aria-expanded', 'false');
//           otherHeading.classList.remove('minus-sign');
//         }
//       });

//       heading.classList.remove('block-collapsed');
//       heading.classList.add('minus-sign');
//       heading.setAttribute('aria-expanded', 'true');
//     } else {
//       heading.classList.add('block-collapsed');
//       heading.setAttribute('aria-expanded', 'false');
//       heading.classList.remove('minus-sign');
//     }
//   }

//   const footerHeadings = document.querySelectorAll('.grid .footer-block__heading');

//   footerHeadings.forEach((heading, index) => {
//     if (index !== 0 && index !== footerHeadings.length - 1) {
//       // Exclude the first and last children and give a class to middle tabs
//       heading.classList.add('block-collapsed', 'middle');
//       heading.setAttribute('aria-expanded', 'false');

//       heading.nextElementSibling.setAttribute('id', footer-block-index-${index});
//       heading.setAttribute('aria-controls', footer-block-index-${index});

//       heading.addEventListener('click', () => { handleCollapse(heading) });
//       heading.addEventListener('keypress', () => { handleCollapse(heading) });
//     }
//   });
// });


 // Footer Accordian Tabs Script END

// ====================================


var searchHeroInput = document.getElementById('Search--hero');

// Get the element with id #SearchMobile
var mobileSearchInput = document.getElementById('SearchMobile');

// Add a focus event listener to the #Search--hero input
searchHeroInput.addEventListener('focus', function() {
    // Do whatever you want with the #SearchMobile input here
    // For example, set its value
     mobileSearchInput.focus();
    console.log('ksksksksk')
});



//  ========== simpl popup=======

 window.addEventListener('load', (event) => {
      // This code runs after the webpage has fully loaded
      let simpBtn = document.querySelector("#infoImage");
      simpBtn.addEventListener("click", () => {
        document.querySelector("body").classList.add('sipm');
      });
    });

